//#region IMPORTS
import { fromBackendDate } from "../../helpers/fromBackendDate";
import { InstoreTemplate } from "../../models/instoreTemplate";
import InstoreTemplatesTableRowActionActive from "./InstoreTemplatesTableRowActionActive";
import InstoreTemplatesTableRowActionCopy from "./InstoreTemplatesTableRowActionCopy";
import InstoreTemplatesTableRowActionEdit from "./InstoreTemplatesTableRowActionEdit";
import MainTableRowActionDelete from "../_layout/MainTableRowActionDelete";
//#endregion

//#region INTERFACE
interface Props {
  editOrCopyHandler: (copy: boolean) => void;
  instoreTemplate: InstoreTemplate;
  deleteHandler: () => void;
  loading?: boolean;
  isAdmin?: boolean;
}
//#endregion

export default function InstoreTemplatesTableRow({
  editOrCopyHandler,
  instoreTemplate,
  deleteHandler,
  loading = false,
  isAdmin = false,
}: Props) {
  //#region RENDER
  return (
    <tr className="border-t border-slate-300 h-10">
      {/* read */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        <div className="flex items-center gap-2">
          <InstoreTemplatesTableRowActionEdit
            instoreTemplate={instoreTemplate}
            editHandler={() => editOrCopyHandler(false)}
          />

          <InstoreTemplatesTableRowActionCopy
            instoreTemplate={instoreTemplate}
            copyHandler={() => editOrCopyHandler(true)}
          />
        </div>
      </td>

      {/* active */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-900">
        <InstoreTemplatesTableRowActionActive
          instoreTemplate={instoreTemplate}
          disabled={loading}
        />
      </td>

      {/* name */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {instoreTemplate.name}
      </td>

      {/* order_type */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {instoreTemplate.order_type_name}
      </td>

      {/* from */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {fromBackendDate(instoreTemplate.from)}
      </td>

      {/* until */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {fromBackendDate(instoreTemplate.until)}
      </td>

      {/* delete */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-900">
        <MainTableRowActionDelete
          deleteHandler={deleteHandler}
          tooltipId={`instoreTemplate${instoreTemplate.id}`}
          hide={!isAdmin}
        />
      </td>
    </tr>
  );
  //#endregion
}
